import { SCREEN, UPLOAD_ID_PARAM } from "../../utils/constants";
import {leadInfo, setLeadInfo} from "../../utils/variables";
import { getClassScreen, navigate, params } from "../events/movePages";
import { uploadPhotosListeners } from "../events/uploadPhotosListeners";

export function loadUploadPhotosLandingPage() {
    setLeadInfo({
        text_id: params(UPLOAD_ID_PARAM)
    });
    uploadPhotosListeners();
    let backArrowDom = document.querySelector('.uploadPhotos__container .back-arrow');
    if (backArrowDom) backArrowDom.style.visibility = 'hidden';
    let backButtonDom = document.querySelector('.uploadPhotos__container .uploadPhotos__actions');
    if (backButtonDom) backButtonDom.style.display = 'none';
    document.querySelector(getClassScreen(SCREEN.UPLOAD_PHOTOS)).style.transition = 'none';
    navigate(SCREEN.UPLOAD_PHOTOS);
}